import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import _ from "lodash";
import {
  loadRoleRequested,
  storeRoleRequested,
  storePermissionRoleRequested,
  loadAllRoleWithPermissionRequested,
} from "store/roles/roleSlice";

interface RoleClaim {
  value: string;
}

interface Role {
  roleName: string;
  roleId: number;
  description: string;
  roleClaims: RoleClaim[];
}

interface GroupedRole {
  roleName: string;
  roleId: number;
  description: string;
  roleClaims: RoleClaim[][];
}
//load roles
export function useLoadRoles() {
  const dispatch = useDispatch();

  const onLoadRoles = useCallback(async () => {
    await dispatch(loadRoleRequested({ page: 1, pageSize: 15 }));
  }, [dispatch]);

  useEffect(() => {
    onLoadRoles();
  }, [onLoadRoles]);

  return { onLoadRoles };
}

//store post
export function useStoreRole() {
  const dispatch = useDispatch();

  const onStoreRole = useCallback(
    async (values: any) => {
      await dispatch(
        storeRoleRequested({
          roleName: values?.roleName,
          description: values?.description,
        })
      );
    },
    [dispatch]
  );
  return { onStoreRole };
}

//store permission for role
export function useStorePermissionRole() {
  const dispatch = useDispatch();

  const onStorePermissionRole = useCallback(
    async (values: any) => {
      await dispatch(
        storePermissionRoleRequested({
          roleId: values?.roleId,
          permissionId: values?.permissionId,
        })
      );
    },
    [dispatch]
  );
  return { onStorePermissionRole };
}

export function useLoadRolesWithPermisions() {
  const dispatch = useDispatch();

  const onLoadRoleswithPermissions = useCallback(async () => {
    await dispatch(
      loadAllRoleWithPermissionRequested({ page: 1, pageSize: 15 })
    );
  }, [dispatch]);

  useEffect(() => {
    onLoadRoleswithPermissions();
  }, [onLoadRoleswithPermissions]);

  return { onLoadRoleswithPermissions };
}

export function useRoles(rolesPermission: Role[]): GroupedRole[] {
  let groupedRoles: GroupedRole[] = [];

  rolesPermission.forEach((role) => {
    const groupedData = Object.values(
      _.groupBy(role.roleClaims, (claim) => claim.value.split(".")[0])
    );

    groupedRoles.push({
      roleName: role.roleName,
      roleId: role.roleId,
      description: role.description,
      roleClaims: groupedData,
    });
  });

  return groupedRoles;
}
